import { calculateBattery } from "utils/device";

const CameraUnits = [
	"2d001a-3133510a-30313433",
	"3e0040-31335102-30313433",
	"23002e-3233510b-38373433",
	"45002a-3233510b-38373433",
	"48002a-3233510b-38373433",
	"370028-3233510b-38373433",
	"480027-3233510b-38373433",
	"49002d-3233510b-38373433",
	"1d002e-3233510b-38373433",
	"450039-31335104-30313433",
	"41001e-31335102-30313433"
];

export const fields = {
	'battery': {
		field: 'battery',
		label: 'Battery',
		server_name: 'battery_reading',
		gradient: (gradientBg) => {
		    gradientBg.addColorStop(0, "rgba(44,255,0,0.6)");
		    gradientBg.addColorStop(0.20, "rgba(85,240,0,0.6)");
		    gradientBg.addColorStop(0.70, "rgba(241,214,0,0.6)");
		    gradientBg.addColorStop(0.85, "rgba(255,85,0,0.6)");
		    gradientBg.addColorStop(1, "rgba(204,0,0,0.6)");
		},
		transform_data: (uuid, row) => {
			// console.log(row);
			var voltage_multiplier = 0.4125;

			if(CameraUnits.indexOf(uuid) > -1){
				voltage_multiplier = 0.825;
			}

			row.max = calculateBattery(row.max, false, voltage_multiplier);
			row.min = calculateBattery(row.min, false, voltage_multiplier);
			row.mean = calculateBattery(row.mean, false, voltage_multiplier);

			return row;
		},
		min: 0,
		max: 100

	},
	'rssi': {
	  field: 'rssi', 
	  label: 'RSSI',
	  server_name: 'rssi',
	  gradient: (gradientBg) => {
	    gradientBg.addColorStop(1, "rgba(19,0,0,0.6)");
	    gradientBg.addColorStop(0.8, "rgba(195,0,0,0.6)");
	    gradientBg.addColorStop(0.7, "rgba(255,89,0,0.6)");
	    gradientBg.addColorStop(0.6, "rgba(255,179,0,0.6)");
	    gradientBg.addColorStop(0.5, "rgba(255,205,0,0.6)");
	    gradientBg.addColorStop(0.35, "rgba(208,229,0,0.6)");
	    gradientBg.addColorStop(0.2, "rgba(150,240,0,0.6)");
	    gradientBg.addColorStop(0, "rgba(44,255,0,0.6)");
	  },
	  transform_data: (uuid, row) => {
	  	if(row.max > 0){
	  		row.min *= -1;
	  		row.max *= -1;
	  		row.mean *= -1;
	  	}
	  	return row;
	  },
	  min: -113,
	  max: -51
	},
	'temperature': {
	  field: 'temperature', 
	  label: 'Temperature',
	  server_name: 'internal_temp',
	  gradient: (gradientBg) => {
		    gradientBg.addColorStop(0, "rgba(92,8,0,0.6)");
		    gradientBg.addColorStop(0.1, "rgba(223,0,0,0.6)");
		    gradientBg.addColorStop(0.2, "rgba(255,128,0,0.6)");
		    gradientBg.addColorStop(0.32, "rgba(255,205,0,0.6)");
		    gradientBg.addColorStop(0.40, "rgba(222,243,5,0.6)");
		    gradientBg.addColorStop(0.48, "rgba(177,249,3,0.6)");
		    gradientBg.addColorStop(0.55, "rgba(125,255,0,0.6)");
		    gradientBg.addColorStop(0.6, "rgba(60,255,79,0.6)");
		    gradientBg.addColorStop(0.65, "rgba(0,255,149,0.6)");
		    gradientBg.addColorStop(0.7, "rgba(0,211,255,0.6)");
		    gradientBg.addColorStop(0.8, "rgba(0,151,255,0.6)");
		    gradientBg.addColorStop(0.9, "rgba(0,89,175,0.6)");
		    gradientBg.addColorStop(1, "rgba(0,0,0,0.6)");
		},
		transform_data: (uuid, row) => {

			return row;
		},
		min: -20,
		max: 70
	},
	'humidity': {
	  field: 'humidity', 
	  label: 'Humidity',
	  server_name: 'internal_humidity',
	  gradient: (gradientBg) => {
        gradientBg.addColorStop(0, "rgba(255,94,0,1)");
        gradientBg.addColorStop(0.1, "rgba(214,118,0,1)");
        gradientBg.addColorStop(0.43, "rgba(141,168,0,0.6)");
        gradientBg.addColorStop(1, "rgba(0,156,21,0.6)");
	  },
	  transform_data: (uuid, row) => {

	  	return row;
	  },
	  min: 0,
	  max: 100
	}
};